import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';

export default function PlasmidChoiceAndAmount({amount, unit, children, onChange}) {
  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 9 }}>
        {children}
      </Grid>
      <Grid size={{ xs: 3 }}>
        <TextField
          margin="dense"
          label=" "
          fullWidth
          variant="standard"
          value={amount}
          slotProps={{
            input: {
              endAdornment: <InputAdornment position="end">{unit}</InputAdornment>,
            },
            htmlInput: {inputMode: "numeric"},
          }}
          sx={{input: {textAlign: "right"}}}
          aria-readonly={true}
          onChange={onChange}
        />
      </Grid>
    </Grid>
  )
}
